// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5e73713d","239":"a6fa034c","455":"0554effd"}[chunkId] + ".chunk.js";
};